<nav>
  <app-logo></app-logo>
  <app-left-toggle (toggleSidebar)="toggleSidebar.emit()"></app-left-toggle>
  <div class="nav-topbar">
    <app-breadcrumb></app-breadcrumb>
    <app-profile></app-profile>
  </div>
</nav>
